export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_LINK = "RESET_LINK";
export const USER_INFORMATION = "USER_INFORMATION";
export const ALL_USER_LIST = "ALL_USER_LIST";
export const USER_HELPER = "USER_HELPER";
export const USER_SETTINGS = "USER_SETTINGS";
export const CUSTOMER_TAG = "CUSTOMER_TAG";
export const GET_CUSTOMER_TAG = "GET_CUSTOMER_TAG";
export const UPDATE_CUSTOMER_TAG = "UPDATE_CUSTOMER_TAG";
export const DELETE_CUSTOMER_TAG = "DELETE_CUSTOMER_TAG";
export const IS_VALID_CUSTOMER_TAG = "IS_VALID_CUSTOMER_TAG";
export const SKILL_MANAGEMENT = "SKILL_MANAGEMENT";
export const CREATE_SKILL = "CREATE_SKILL";
export const EDITSKILL = "EDITSKILL";
export const QUEUE_TRACKER_DATA = "QUEUE_TRACKER_DATA";
export const AGENT_TRACKER_DATA = "AGENT_TRACKER_DATA";
export const NOTIFICATION = "NOTIFICATION";
export const SIDEBAR_OVERLAY_SETTINGS = "SIDEBAR_OVERLAY_SETTINGS";
export const SIDEBAR_OVERLAY_CLOSE_SETTINGS = "SIDEBAR_OVERLAY_CLOSE_SETTINGS";
export const SIDEBAR_OVERLAY_CONTACTS = "SIDEBAR_OVERLAY_CONTACTS";
export const SIDEBAR_OVERLAY_CLOSE_CONTACTS = "SIDEBAR_OVERLAY_CLOSE_CONTACTS";
export const CONTACTS_MENU = "CONTACTS_MENU";
export const SIDEBAR_OVERLAY_COLLAPSE = "SIDEBAR_OVERLAY_COLLAPSE";
export const SETTINGS_MENU = "SETTINGS_MENU";
export const SIDE_BAR = "SIDE_BAR";
export const PLAY_PROMPT_DATA = "PLAY_PROMPT_DATA";
export const USER_DETAILS = "USER_DETAILS";
export const EDIT_USER_DETAILS = "EDIT_USER_DETAILS";
export const ALL_ROUTING_PROFILE_LIST = "ALL_ROUTING_PROFILE_LIST";
export const CONTACT_CENTER_NUMBER = "CONTACT_CENTER_NUMBER";
export const REPORTS_DATA = "REPORTS_DATA";
export const SUPERVISOR_CONTACT_DATA = "SUPERVISOR_CONTACT_DATA";
export const BUSINESS_HOURS = "BUSINESS_HOURS";
export const GET_CUSTOM_LIST = "GET_CUSTOM_LIST";
export const CUSTOM_QUEUE = "CUSTOM_QUEUE";
export const AGENT_WORKSPACE_SLICE = "AGENT_WORKSPACE_SLICE";
export const AGENT_STATUS = "AGENT_STATUS";
export const AGENT_STATE = "AGENT_STATE";
export const NODE_FLOW = "NODE_FLOW";
export const META_TEMPLATES = "META_TEMPLATES";
export const CALL_USER_DETAILS = "CALL_USER_DETAILS";
export const CHAT_CONFIGURATION = "CHAT_CONFIGURATION";
export const CHAT_REDUCER = "CHAT_REDUCER";
export const MEET_REDUCER = "MEET_REDUCER";
export const VBG_REDUCER = "VBG_REDUCER";
export const CLOSE_CAPTION="CLOSE_CAPTION";
export const STORE_VIDEO_REDUCER = "STORE_VIDEO_REDUCER";
export const CALL_USER_AGENT_REDUCER = "CALL_USER_AGENT_REDUCER";
export const POPUP_CALLS = "POPUP_CALLS";
export const ALL_CONTACT_LIST = "ALL_CONTACT_LIST";
export const CHAT_WIDGETS = "CHAT_WIDGETS";
export const SMS = "SMS";
export const CO_CHAT = "CO_CHAT";
export const CO_CHAT_DETAILS = "CO_CHAT_DETAILS";
export const DISPOSITION_STATUS = "DISPOSITION_STATUS";
export const DYNAMIC_DASHBOARD = "DYNAMIC_DASHBOARD";
export const SHORTCUTKEYS = "SHORTCUTKEYS";
export const EMAIL_CONFIG = "EMAIL_CONFIG";
export const CO_CHAT_USER_DETAILS = "CO_CHAT_USER_DETAILS";
export const REPORT_CALL_ANSWERED = "REPORT_CALL_ANSWERED";
export const INTERNAL_CHAT = "INTERNAL_CHAT";
export const DASH_BOARD = "DASH_BOARD";
export const ALL_ACTIVITY = "ALL_ACTIVITY";
export const EMAIL_ENTRIES = "EMAIL_ENTRIES";
export const QA_DATA = "QA_DATA";
export const SATNDALONE_BOT = "SATNDALONE_BOT";
export const KNOWLEDGEBASE = "KNOWLEDGEBASE";
export const CONNECTORS = "CONNECTORS";
export const LIVE_TRACKER = "LIVE_TRACKER";
export const APIINTEGRATION = "APIINTEGRATION";
export const CALL_CONFIG = "CALL_CONFIG";
export const WHATSAPP_CONFIG="WHATSAPP_CONFIG"
export const FACEBOOK_CONFIG="FACEBOOK_CONFIG"
export const SOCIALMEDIA_WIDGET="SOCIALMEDIA_WIDGET"
export const MEET_DETAILS="MEET_DETAILS";
export const MEDIA_INFO="MEDIA_INFO";
export const VIDEO_USER_AGENT="VIDEO_USER_AGENT";
export const SCREENSHARE_INFO = "SCREENSHARE_INFO";
export const CC="CC";
export const VOICE_QUEUE_ANALYTICS="VOICE_QUEUE_ANALYTICS";
export const WEBCHAT_QUEUE_ANALYTICS="WEBCHAT_QUEUE_ANALYTICS";
export const SOCIALMEDIA_QUEUE_ANALYTICS="SOCIALMEDIA_QUEUE_ANALYTICS";
export const WEBCHAT_AGENT_ANALYTICS="WEBCHAT_AGENT_ANALYTICS";
export const EMAIL_AGENT_ANALYTICS="EMAIL_AGENT_ANALYTICS";
export const VOICE_AGENT_ANALYTICS="VOICE_AGENT_ANALYTICS";
export const SMS_AGENT_ANALYTICS="SMS_AGENT_ANALYTICS";
export const WHATSAPP_AGENT_ANALYTICS="WHATSAPP_AGENT_ANALYTICS";
export const FACEBOOK_AGENT_ANALYTICS="FACEBOOK_AGENT_ANALYTICS";
export const INSTAGRAM_AGENT_ANALYTICS="INSTAGRAM_AGENT_ANALYTICS";
export const CUSTOMER_SATISFACTON ="CUSTOMER_SATISFACTON";
export const OUTBOUND_CAMPAIGN="OUTBOUND_CAMPAIGN";
